import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as ifaSearchProductsState from '../employee-detail.reducer';
import * as ifaSearchProductsReducer from '../reducers/ifa-search-products.reducer';

export const getIFASearchProducts = createSelector(
  ifaSearchProductsState.getIFASearchProductsState,
  ifaSearchProductsReducer.getIFASearchProducts
);
